module.exports = __webpack_public_path__ + "img/in.67bdffb8.svg";